import React from 'react';
import SvgIcon from '@mui/material/SvgIcon';

const CaretDoubleNextIcon = (props) => (
  <SvgIcon viewBox="0 0 16 15" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15.6168 8.11883L9.49322 14.2424C9.15151 14.5841 8.59749 14.5841 8.25578 14.2424C7.91407 13.9007 7.91407 13.3467 8.25578 13.0049L13.7606 7.50011L8.25578 1.99528C7.91407 1.65357 7.91407 1.09955 8.25578 0.757841C8.59749 0.416133 9.15151 0.416133 9.49322 0.757841L15.6168 6.88139C15.9585 7.2231 15.9585 7.77712 15.6168 8.11883Z"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.74322 8.11883L1.61968 14.2424C1.27797 14.5841 0.723951 14.5841 0.382242 14.2424C0.0405341 13.9007 0.0405341 13.3467 0.382242 13.0049L5.88707 7.50011L0.382242 1.99528C0.0405341 1.65357 0.0405341 1.09955 0.382242 0.757841C0.723951 0.416133 1.27797 0.416133 1.61968 0.757841L7.74322 6.88139C8.08493 7.2231 8.08493 7.77712 7.74322 8.11883Z"
    />
  </SvgIcon>
);

export default CaretDoubleNextIcon;

